import React from "react";
import { useMultiMessenger } from "@/hooks/useMultiMessenger";
import MessengerChatWindow from "./messenger-chat-window";

export default function MultiChatContainer() {
  const { openChats, closeChat, minimizeChat, expandChat } = useMultiMessenger();

  if (openChats.length === 0) {
    return null;
  }

  // On mobile, don't show chat windows - they will be handled by navigation to /chat/[userId]
  return (
    <div className="hidden lg:block fixed bottom-0 right-4 z-50 flex gap-2 flex-row-reverse pointer-events-none items-end">
      <div className="flex gap-2 pointer-events-auto items-end">
        {openChats.map((chatWindow, index) => {
          // Calculate rightOffset for positioning, assuming chat windows stack from right to left
          // Each chat window is roughly 360px wide, plus 8px gap
          const rightOffset = index * (360 + 8);
          return (
            <MessengerChatWindow
              key={chatWindow.id}
              chatWindow={{
                ...chatWindow,
                user: {
                  ...chatWindow.user,
                  profileImageUrl: chatWindow.user.profileImageUrl || undefined
                }
              }}
              onClose={() => closeChat(chatWindow.id)}
              onMinimize={() => minimizeChat(chatWindow.id)}
              onExpand={() => expandChat(chatWindow.id)} // Keep onExpand as it was in original
              style={{ right: `${rightOffset}px` }}
            />
          );
        })}
      </div>
    </div>
  );
}